import { HelperManager, helperManager } from '../utils/Helper';
import { $body, $document } from '../global';
import { blockManager } from './blocks';
import { gridMenuManager } from './grid-menu';
import { overlayManager } from './overlay';
class PrintManager {
    pageContainer;
    busy = false;
    hiddenSections;
    overlayTitleText;
    overlaySubtitleText;
    overlayText;
    overlayCurrentPageBtnText;
    overlayMoreTitleText;
    overlayMoreSubtitleText;
    overlayMoreText;
    autoCloseTab = false;
    constructor(pageContainer = $('main')) {
        this.pageContainer = pageContainer;
        if (HelperManager.getHash('print'))
            this.autoPrint();
    }
    autoPrint() {
        this.autoCloseTab = true;
        $document.ready(() => {
            setTimeout(() => {
                const visibleOverlay = $('.Overlay-Visible');
                if (visibleOverlay.length) {
                    this.printOverlay(visibleOverlay);
                }
                else {
                    this.printPage();
                }
            }, 2000);
        });
    }
    async print(elem, showRelatedPages = false) {
        if (this.busy)
            return;
        this.busy = true;
        const block = $(elem).closest('.Block');
        if (block.length) {
            this.printBlock(block);
            return;
        }
        const overlay = $(elem).closest('.Overlay');
        if (overlay.length) {
            this.printOverlay(overlay);
            return;
        }
        if (showRelatedPages) {
            await gridMenuManager.loadAllGrids();
            this.showPrintOverlay(() => this.printPage(), $(elem));
        }
        else {
            this.printPage();
        }
    }
    showPrintOverlay(printCallback, elem = null) {
        const printableBlocks = [];
        $('main .Block').each((i, elem) => {
            const block = $(elem);
            const links = PrintableBlockHelper.getLinks(block);
            if (links.length && !block.hasClass('ForcePrint'))
                printableBlocks.push(new PrintableBlock(block, links));
        });
        if (!printableBlocks.length) {
            printCallback();
            return;
        }
        if (elem)
            this.initResourceStrings(elem);
        const overlay = this.getPrintOverlay(printableBlocks);
        const printBtn = overlay.find('.Overlay_PrintBtn');
        printBtn.on('click', () => {
            printCallback();
        });
        overlayManager.open(overlay, this);
    }
    onClose() {
        this.busy = false;
    }
    initResourceStrings(elem) {
        this.overlayTitleText = elem.data('overlay-title-text') || '';
        this.overlaySubtitleText = elem.data('overlay-subtitle-text') || '';
        this.overlayText = elem.data('overlay-text') || '';
        this.overlayCurrentPageBtnText = elem.data('overlay-current-page-btn-text') || '';
        this.overlayMoreTitleText = elem.data('overlay-more-title-text') || '';
        this.overlayMoreSubtitleText = elem.data('overlay-more-subtitle-text') || '';
        this.overlayMoreText = elem.data('overlay-more-text') || '';
    }
    getPrintOverlay(printableBlocks) {
        const theme = helperManager.getTheme(['Theme-Accent'], $('.Header'));
        const title = HelperManager.htmlEncode(this.overlayTitleText);
        const subtitle = HelperManager.htmlEncode(this.overlaySubtitleText);
        const text = HelperManager.htmlEncode(this.overlayText);
        const moreTitle = HelperManager.htmlEncode(this.overlayMoreTitleText);
        const moreSubtitle = HelperManager.htmlEncode(this.overlayMoreSubtitleText);
        const moreText = HelperManager.htmlEncode(this.overlayMoreText);
        const currentPageBtnText = HelperManager.htmlEncode(this.overlayCurrentPageBtnText);
        const overlayHTML = `
      <div class="HideOnPrint Overlay Overlay-Small Overlay-Share js-GridItem_Overlay ${theme}">
        <div class="Overlay_ContentWrapper ClearFix-Wrapper">
          <hr class="Line">
          <div class="Toolbar">
            <button class="Btn Btn-Square Btn-Default Btn-TextAccent Overlay_CloseBtn"><i class="RIcon-Cross"></i></button>
          </div>
          <div class="Overlay_Content">
            <div class="Overlay_Content-Centered">
              <h3 class="H H2 Block_Title H-NoMarginTop">
                ${title}
                <span class="H_Sub">${subtitle}</span>
              </h3>
              <p>
                ${text}
              </p>
              <p>
                <button class="Btn Btn-Accent Overlay_PrintBtn"><span>${currentPageBtnText}</span></button>
              </p>
              <h4 class="H H2 Block_Title H-NoMarginBottom">
                ${moreTitle}
                <span class="H_Sub">${moreSubtitle}</span>
              </h4>
              <p>
                ${moreText}
              </p>
              <hr class="Line Line-Small" />
              <ul class="List-Clear PrintableLinks_List"></ul>
            </div>
          </div>
        </div>
      </div>`;
        const overlay = $(overlayHTML);
        const list = overlay.find('.PrintableLinks_List');
        printableBlocks.forEach((block) => {
            const title = `<span class="PrintableLinks_Title">${block.title}</span>${block.subTitle ? `<span class="PrintableLinks_SubTitle">${block.subTitle}</span>` : ''}`;
            let accordionItemsHTML = '';
            if (block.accordionItems.length) {
                block.accordionItems.forEach((item) => {
                    if (item.internalHref) {
                        accordionItemsHTML += `<a class="PrintableLinks_SubItem" href="${item.internalHref}" target="_blank"><span class="PrintableLinks_Title">${item.title}</span></a>`;
                    }
                });
            }
            if (block.internalHref || accordionItemsHTML) {
                const item = `<li class="PrintableLinks_Item">${block.internalHref ? `<a href="${block.internalHref}" target="_blank">${title}</a>` : accordionItemsHTML ? title : ''}
        ${accordionItemsHTML}
        </li>`;
                list.append(item);
            }
        });
        return overlay;
    }
    browserPrint() {
        window.print();
        this.resetSections();
        this.busy = false;
        if (this.autoCloseTab)
            window.close();
    }
    async printPage() {
        this.busy = true;
        // In the back-end we don't use the paging in the timelines (Zorgpaden)
        // So if we ever add that we should not only refresh the first page of the grids but all pages
        await gridMenuManager.loadAllGrids();
        this.preparePage();
    }
    preparePage() {
        const blocks = $('main .Block');
        if (!blocks.length)
            return this.browserPrint();
        helperManager.showAllImages($body, () => {
            const delay = new LoadingImagesDelay();
            const blocksData = [];
            const blocksOverlayData = [];
            blocks.each((index, elem) => {
                const $block = $(elem);
                this.prepareBlock($block, (block, originalBlockContainer, overlays) => {
                    blocksData.push(new BlockInfo(block, originalBlockContainer, overlays));
                    overlays.each((index, elem) => {
                        const overlay = $(elem);
                        delay.addImage();
                        this.preparePrintOverlay(overlay, true, () => delay.loadedImage());
                    });
                }, (overlay, originalOverlayContainer) => {
                    delay.addImage();
                    this.preparePrintOverlay(overlay, true, () => delay.loadedImage());
                    blocksOverlayData.push(new BlockOverlayInfo($block, overlay, originalOverlayContainer));
                }, false);
            });
            delay.continueWith(() => {
                const sections = $('main > section, main > div > section');
                if (sections.length)
                    this.prepareSections(sections);
                this.printBlockAndOverlaysAndReset(blocksData, blocksOverlayData);
            });
        });
    }
    printBlock(block = null) {
        this.busy = true;
        helperManager.showAllImages(block, () => {
            const delay = new LoadingImagesDelay();
            const blocksData = [];
            const blocksOverlayData = [];
            this.prepareBlock(block, (block, originalBlockContainer, overlays) => {
                blocksData.push(new BlockInfo(block, originalBlockContainer, overlays));
                overlays.each((index, elem) => {
                    const overlay = $(elem);
                    delay.addImage();
                    this.preparePrintOverlay(overlay, false, () => delay.loadedImage());
                });
            }, (overlay, originalOverlayContainer) => {
                delay.addImage();
                this.preparePrintOverlay(overlay, false, () => delay.loadedImage());
                blocksOverlayData.push(new BlockOverlayInfo(block, overlay, originalOverlayContainer));
            });
            delay.continueWith(() => {
                this.printBlockAndOverlaysAndReset(blocksData, blocksOverlayData);
            });
        });
    }
    printOverlay(overlay = null, callback = null, showPageContent = false) {
        this.busy = true;
        this.preparePrintOverlay(overlay, showPageContent, () => {
            this.browserPrint();
            this.resetPrintOverlay(overlay, true);
            if (callback)
                callback();
        });
    }
    printBlockAndOverlaysAndReset(blocksData, blocksOverlayData) {
        // Wait 2 frames until the layout and images have been rendered before printing
        requestAnimationFrame(() => requestAnimationFrame(() => {
            this.browserPrint();
            for (const blockData of blocksData) {
                blockData.block.insertAfter(blockData.originalBlockContainer);
                blockData.originalBlockContainer.remove();
                blockData.overlays.each((index, elem) => {
                    const overlay = $(elem);
                    this.resetPrintOverlay(overlay);
                });
            }
            for (const overlayData of blocksOverlayData) {
                this.resetPrintOverlay(overlayData.overlay);
                this.resetBlock(overlayData.block, overlayData.overlay, overlayData.originalOverlayContainer);
            }
        }));
    }
    prepareBlock(block = null, blockCallback = null, overlayCallback = null, justOneBlock = true) {
        const overlays = this.getOverlaysFromBlock(block);
        // console.log(`print should hide check: ${!block.hasClass('HideOnPrint')} ${!block.children('.js-Accordion').length} ${!!overlays.length} ${!!block.find('.Btn').length} ${!!block.find('.js-Video').length}`);
        // Hide a block when...
        if (!block.hasClass('HideOnPrint') && // it is not hidden already and
            !block.children('.js-Accordion').length && // is no accordionblock and
            (overlays.length || // has (overlays or
                (block.find('.Btn').length && !block.hasClass('ForcePrint')) || // buttons or
                block.find('.js-Video').length) //      videos)
        ) {
            block.addClass('HideOnPrint').data('HiddenForOverlayPrintView', true);
        }
        else {
            const originalBlockContainer = $(document.createElement('div'));
            originalBlockContainer.insertAfter(block);
            if (justOneBlock)
                $body.append(block);
            if (blockCallback)
                blockCallback(block, originalBlockContainer, overlays);
        }
        if (!overlays.length || block.children('.js-Accordion').length)
            return;
        const gridItem = block.closest('.js-GridItem_Wrapper');
        let lastAddedPrintable;
        overlays.each((index, elem) => {
            const overlay = $(elem);
            const originalOverlayContainer = $(document.createElement('div'));
            originalOverlayContainer.insertAfter(overlay);
            if (!justOneBlock && gridItem.length) {
                overlay.insertAfter(lastAddedPrintable || gridItem);
                lastAddedPrintable = overlay;
            }
            else {
                $body.append(overlay);
            }
            if (overlayCallback)
                overlayCallback(overlay, originalOverlayContainer);
        });
    }
    getOverlaysFromBlock($block = null) {
        const block = blockManager.getBlock($block[0]);
        const overlay = block.getOverlay();
        const overlays = this.getAccordionOverlaysFromBlock(block);
        return overlay ? overlays.add(overlay) : overlays;
    }
    getAccordionOverlaysFromBlock(block) {
        const accordionBtns = block.element.find('.Accordion_Content .Btn');
        const overlays = [];
        $(accordionBtns).each((index, elem) => {
            const overlay = block.getOverlay($(elem));
            if (overlay)
                overlays.push(overlay[0]);
        });
        return $(overlays);
    }
    preparePrintOverlay(overlay = null, showPageContent = false, onImagesLoaded) {
        $body.addClass('OverlayPrintView');
        if (!showPageContent)
            $body.addClass('OverlayPrintView-HideDetail');
        overlay.addClass('Overlay-PrintView').addClass('Overlay-Visible');
        showPageContent
            ? onImagesLoaded()
            : helperManager.showAllImages(overlay, () => onImagesLoaded());
    }
    prepareSections(sections) {
        this.hiddenSections = sections.filter((i, elem) => {
            const section = $(elem);
            return !section.hasClass('HideOnPrint') && section.has('.js-Grid').length && !section.has('.Block:not(.HideOnPrint)').length && !section.has('.js-Grid > .Overlay-PrintView').length;
        });
        this.hiddenSections.addClass('HideOnPrint');
    }
    resetBlock($block, overlay, originalOverlayContainer = null) {
        if ($block.data('HiddenForOverlayPrintView')) {
            $block.removeData('HiddenForPreview').removeClass('HideOnPrint');
        }
        if (originalOverlayContainer) {
            overlay.removeClass('Overlay-Visible');
            overlay.insertAfter(originalOverlayContainer);
            originalOverlayContainer.remove();
        }
    }
    resetPrintOverlay(overlay = null, keepVisible = false) {
        $body.removeClass('OverlayPrintView').removeClass('OverlayPrintView-HideDetail');
        overlay.removeClass('Overlay-PrintView');
        if (!keepVisible) {
            overlay.removeClass('Overlay-Visible');
        }
    }
    resetSections() {
        if (!this.hiddenSections)
            return;
        this.hiddenSections.removeClass('HideOnPrint');
        this.hiddenSections = null;
    }
}
const printManager = new PrintManager();
window.printManager = printManager;
class BlockOverlayInfo {
    block;
    overlay;
    originalOverlayContainer;
    constructor(block, overlay, originalOverlayContainer) {
        this.block = block;
        this.overlay = overlay;
        this.originalOverlayContainer = originalOverlayContainer;
    }
}
class BlockInfo {
    block;
    originalBlockContainer;
    overlays;
    constructor(block, originalBlockContainer, overlays) {
        this.block = block;
        this.originalBlockContainer = originalBlockContainer;
        this.overlays = overlays;
    }
}
class LoadingImagesDelay {
    loading = 0;
    loaded = 0;
    onLoaded = null;
    addImage() {
        this.loading++;
    }
    canContinue() {
        return this.onLoaded && this.loaded === this.loading;
    }
    loadedImage() {
        this.loaded++;
        if (this.canContinue())
            this.onLoaded();
    }
    continueWith(callback) {
        this.onLoaded = callback;
        if (this.canContinue())
            this.onLoaded();
    }
}
class PrintableAccordionItem {
    listItem;
    link;
    constructor(listItem, link) {
        this.listItem = listItem;
        this.link = link;
    }
    get title() {
        const itemTitle = this.listItem.find('.js-Accordion_Title').first();
        let title = '?';
        if (itemTitle.length)
            title = itemTitle.text().replace(/\s+/g, ' ').trim();
        return title;
    }
    get internalHref() {
        if (!this.link)
            return null;
        if (!helperManager.aIsInternalWebsiteLink(this.link))
            return null;
        const href = this.link.attr('href');
        const param = href.indexOf('#') === -1 ? '#' : '&';
        return `${href}${param}print=true`;
    }
}
class PrintableBlockHelper {
    static getLinks(block) {
        return block.find('.Btn[href]:not([onclick])').filter((i, elem) => {
            return !$(elem).closest('.Overlay').length;
        });
    }
}
class PrintableBlock {
    block;
    link;
    accordionItems = [];
    constructor(block, links) {
        this.block = block;
        links.each((i, elem) => {
            const link = $(elem);
            const accordionContent = link.closest('.js-Accordion_Content');
            if (accordionContent.length) {
                const listItem = accordionContent.closest('li');
                this.accordionItems.push(new PrintableAccordionItem(listItem, link));
            }
            else {
                this.link = link;
            }
        });
    }
    get title() {
        let blockTitle = this.block.find('.Block_Title').first();
        if (!blockTitle.length) {
            blockTitle = this.block.find('.Btn').first();
        }
        const title = blockTitle.length ? this.getText($(blockTitle.contents()[0])) : '';
        return title || '?';
    }
    get subTitle() {
        const blockTitle = this.block.find('.Block_Title').first();
        return (blockTitle.length) ? this.getText(blockTitle.find('.H_Sub')) : '';
    }
    get internalHref() {
        if (!this.link)
            return null;
        if (!helperManager.aIsInternalWebsiteLink(this.link))
            return null;
        const href = this.link.attr('href');
        const param = href.indexOf('#') === -1 ? '#' : '&';
        return `${href}${param}print=true`;
    }
    getText(elem) {
        return elem.text().replace(/\s+/g, ' ').trim();
    }
}
export { 
// types
PrintableAccordionItem, PrintableBlock, PrintableBlockHelper, PrintManager, 
// globals
printManager };
